import { KeyboardEvent, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import SearchResults from '~/components/SearchRoom/SearchResults/SearchResults';
import { Input } from '~/components/atomic';
import { HelmetHead } from '~/components/common';

export default function SearchRoom() {
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputText, setInputText] = useState('');
  const [value, setValue] = useState('');

  const handleSearchKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
      setValue(inputText);
      inputRef.current?.blur();
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <HelmetHead title='Search' />

      <Container>
        <SearchHeader>
          <Input
            ref={inputRef}
            id='search'
            text={inputText}
            setText={setInputText}
            placeholder='Search'
            leftIconName='Search'
            isFullWidth
            onKeyDown={handleSearchKeyDown}
            deleteAllTextOpt
          />
          <CancelButton onClick={() => navigate(-1)}>Cancel</CancelButton>
        </SearchHeader>

        <SearchResults query={value} />
      </Container>
    </>
  );
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 8px 16px;
  gap: 24px;
`;

export const SearchHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const CancelButton = styled.button`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 4px 16px;
  gap: 8px;
  color: ${({ theme }) => theme.content.content_light_1};
  ${({ theme }) => theme.fontStyle.label.button16_medium};
`;
